// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import AccountDrawerLabels from '@tcp/core/src/components/features/account/AccountDrawer/views/AccountDrawerView/views/AccountDrawer.labels';

const GuestUserInfo = dynamic(() =>
  // eslint-disable-next-line extra-rules/no-commented-out-code
  import(/* webpackChunkName: "guest-user-info" */ '../GuestUserInfo/view/GuestUserInfo')
);

const LoggedInUserInfo = dynamic(() =>
  // eslint-disable-next-line extra-rules/no-commented-out-code
  import(/* webpackChunkName: "loggedin-user" */ '../LoggedInUserInfo/view/LoggedInUserInfo')
);

const onLinkClickHandler = (params, closeDrawer, onLinkClick) => {
  closeDrawer();
  onLinkClick(...params);
};

const AccountInfoSection = ({
  brandId,
  userName,
  userPoints,
  userRewards,
  openOverlay,
  userNameClick,
  onLinkClick,
  closeDrawer,
  triggerLoginCreateAccount,
  isMobileNavigationRedesignEnabled,
}) => {
  const accountLabel = getLabelFromCopyOrFromTranslation(
    'global.accountDrawer.lbl_newHeaderLogin_account',
    AccountDrawerLabels
  );
  return (
    <>
      {userName ? (
        <BodyCopy
          id="sideNavUserInfo"
          component="div"
          className={`account-main-section account-main-section-${brandId}${
            isMobileNavigationRedesignEnabled ? ' account-main-section-mobile-redesign' : ''
          }`}
        >
          <Col colSize={{ small: 4, medium: 5 }}>
            <LoggedInUserInfo
              mainId={`accountDrawer ${userName}`}
              userName={userName}
              userPoints={userPoints}
              userRewards={userRewards}
              userNameClick={userNameClick}
              openOverlay={openOverlay}
              onLinkClick={onLinkClick}
              isDrawer
            />
          </Col>
          <Col colSize={{ small: 2, medium: 3 }} className="manage-account-wrapper">
            <BodyCopy
              className="manage-account"
              component="span"
              fontFamily="secondary"
              fontSize="fs10"
              textAlign="right"
            >
              <Anchor
                underline
                to="/account?id=account-overview"
                asPath="/account"
                onClick={() => closeDrawer()}
              >
                {isMobileNavigationRedesignEnabled ? accountLabel : 'Manage account'}
              </Anchor>
            </BodyCopy>
          </Col>
        </BodyCopy>
      ) : (
        <BodyCopy
          id="sideNavUserInfo"
          component="div"
          className={`account-main-section account-main-section-${brandId}${
            isMobileNavigationRedesignEnabled ? ' account-main-section-mobile-redesign' : ''
          }`}
          fontFamily="secondary"
          fontSize="fs14"
        >
          <GuestUserInfo
            createAccount="createAccount"
            login="login"
            triggerLoginCreateAccount={triggerLoginCreateAccount}
            onLinkClick={(...params) => onLinkClickHandler(params, closeDrawer, onLinkClick)}
            openOverlay={openOverlay}
            isDrawer
            userName={userName}
            userPoints={userPoints}
            userRewards={userRewards}
          />
        </BodyCopy>
      )}
    </>
  );
};

AccountInfoSection.propTypes = {
  brandId: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  userPoints: PropTypes.string.isRequired,
  userRewards: PropTypes.string.isRequired,
  openOverlay: PropTypes.func.isRequired,
  userNameClick: PropTypes.bool.isRequired,
  onLinkClick: PropTypes.func.isRequired,
  closeDrawer: PropTypes.func.isRequired,
  triggerLoginCreateAccount: PropTypes.bool.isRequired,
  isNewNavigationImagesEnabled: PropTypes.bool.isRequired,
};
export default AccountInfoSection;
